<template>
    <div class="equipment_cont">
        <div class="equipment_box">
            <div class="equipment_left">
                <div class="equipment_name">
                    Equipment Status
                </div>
                <div class="equipment_unit">
                    <span style="color: #C5C5C5;">
                        {{ equiplabel }}
                    </span>
                    {{ equipunit }}
                </div>
                <div class="equipment_list">
                    <div v-for="(i, index) in facilitiesData" class="info_box"
                        :style="cliskindex == index ? 'transform: scale(1.1);' : ''" @click="choseeq(i, index)">
                        <!-- {{ i.property }} -->
                        <div class="kedu">
                            <div class="tag">
                                <span v-if="i.property[0].target">
                                    {{ i.property[0].target[1] }}
                                </span>
                                <span v-else>
                                    100
                                </span>
                                <div class="long">
                                    <span style="color: rgba(189, 89, 87, 1);"
                                        v-if="i.property[0].target[1] == i.property[0].value">
                                        <div class="short">
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div v-if="i.property[0].target">
                                <div class="goaltag"
                                    v-if="i.property[0].target[1] !== i.property[0].value && i.property[0].target[0] !== i.property[0].value"
                                    :style="(i.property[0].value - i.property[0].target[0]) / (i.property[0].target[1] - i.property[0].target[0]) > 0 ? 'bottom:' + ((i.property[0].value - i.property[0].target[0]) / (i.property[0].target[1] - i.property[0].target[0]) * 100 - 7) + '%;' : 'bottom:' + '-5' + '%;'">
                                    <span style="color: rgba(189, 89, 87, 1);">
                                    </span>
                                    <div class="short">
                                    </div>
                                </div>
                                <div v-for="(item, l) in 9" :key="l" class="tag">
                                    <div class="short2">
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <div v-for="(item, l) in 9" :key="l" class="tag">
                                    <div class="short2">
                                    </div>
                                </div>
                            </div>
                            <div class="tag">
                                <span v-if="i.property[0].target">
                                    {{ i.property[0].target[0] }}
                                </span>
                                <span v-else>
                                    0
                                </span>
                                <div class="long2">
                                    <span style="color: rgba(189, 89, 87, 1);"
                                        v-if="i.property[0].target[0] == i.property[0].value">
                                        <div class="short">
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-if="i.property[0].target">
                            <div class="list_info" :class="i.state == 0 ? 'closeinfo' : 'openinfobox'">
                                <div class="openinfo" v-if="i.state == 1"
                                    :style="'height: ' + (i.property[1].value - i.property[0].target[0]) / (i.property[0].target[1] - i.property[0].target[0]) * 100 + '%;min-height:10%;max-height:100%'">
                                    <div v-if="i.property[1].value !== -999">
                                        {{ i.property[1].value }}
                                    </div>
                                </div>
                                <div class="errorinfo" v-if="i.state == 2">
                                    <div>
                                        <img src="../../../assets/warning(2).png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="info_text" :style="i.state == 0 ? '' : 'color:#40E0D0'">
                                {{ i.id }}
                            </div>
                            <div class="info_status">
                                <div class="status"
                                    :class="i.state == 0 ? 'closetype' : i.state == 1 ? 'opentype' : 'errortype'">
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="list_info" :class="i.state == 0 ? 'closeinfo' : 'openinfobox'">
                                <div class="openinfo" v-if="i.state == 1"
                                    :style="'height: ' + i.property[1].value + '%;'">
                                    <div>
                                        {{ i.property[1].value }}
                                    </div>
                                </div>
                                <div class="errorinfo" v-if="i.state == 2">
                                    <div>
                                        <img src="../../../assets/warning(2).png" alt="">
                                    </div>
                                </div>
                            </div>
                            <div class="info_text" :style="i.state == 0 ? '' : 'color:#40E0D0'">
                                {{ i.id }}
                            </div>
                            <div class="info_status">
                                <div class="status"
                                    :class="i.state == 0 ? 'closetype' : i.state == 1 ? 'opentype' : 'errortype'">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <transition name="moveR">
                <div class="equipment_right" v-if="drawer">
                    <div class="close_btn" @click="closedrawer">
                        <img src="../../../assets/close.png" alt="">
                    </div>
                    <div class="right_top">
                        <div style="display: flex; align-items: center;">
                            <div class="equipment_img">
                                <img class="img1"
                                    :src="equipmentdetail.state === 0 ? img1[equipmentdetail.type].url : equipmentdetail.state === 1 ? img[equipmentdetail.type].url : img2[equipmentdetail.type].url"
                                    :class="equipmentdetail.type == 'FAN' ? equipmentdetail.state === 1 ? justdo : '' : ''" />
                            </div>
                            <div class="equipment_text">
                                <div class="equipment_num"
                                    :style="equipmentdetail.state === 0 ? 'color:rgb(97, 97, 97)' : equipmentdetail.state === 2 ? 'color: #BD5957' : ''">
                                    {{ equipmentdetail.id }}
                                </div>
                                <div class="equipment_type">
                                    {{ equipmentdetail.desc }}
                                    <span v-if="equipmentdetail.state === 2"
                                        style="color: #BD5957;font-weight: 600;display: inline-block;margin-left: 10px;">
                                        Fault
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="equipment_open" @click="changeSwitch(equipmentdetail)"
                            v-if="equipmentdetail.ctrl_btn">
                            <img src="../../../assets/btn(6).png" alt="" v-if="equipmentdetail.ctrl_btn.enable">
                            <img src="../../../assets/开关 (4).png" alt="" v-if="!equipmentdetail.ctrl_btn.enable">
                            <div>
                                <span v-if="equipmentdetail.ctrl_btn.enable">
                                    AI Control Enabled
                                </span>
                                <span v-if="!equipmentdetail.ctrl_btn.enable">
                                    AI Control Disabled
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="right_mid">
                        <div class="mid_box">
                            <div v-for="(i, index) in equipmentdetail.property" class="equipment_tag"
                                :class="tagclick == index ? 'click_tag' : ''" @click="clicktag(i, index)">
                                <p class="setp">{{ i.name }}</p>
                                <p class="valuep">
                                    {{ i.value }}
                                    <span class="kongge"></span>
                                    {{ i.unit }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="right_chart">
                        <div class="minichartbox" @mouseenter="onmouserin()" v-if="changetag">
                            <minichart :codMain="'miniChart' + tagclick" :ChartData="chartData"
                                style="width: 100%;height: 100%;">
                            </minichart>
                        </div>
                    </div>
                </div>
            </transition>
            <!-- </el-drawer> -->
        </div>
    </div>
</template>

<script>
import minichart from "./charts/minichart";
import commonApi from "@/api/common.js";
// import config from '@/utils/config';;

export default {
    components: {
        minichart,
    },
    data() {
        return {
            drawer: false,
            show: true,
            allControlData: null,
            openIndex: null,
            choseid: 0,
            bigchartdata: null,
            activeName: null,
            timer: null,
            equipTitle: null,
            facilitiesData: null,
            eqlength: null,
            cliskindex: 0,
            equipmentdetail: null,
            tagclick: 0,
            chartData: null,
            changetag: false,
            img: {
                PAM: {
                    url: require("../../../assets/PAMopen.png")
                },
                PAC: {
                    url: require("../../../assets/PACopen.png")
                },
                CARBON: {
                    url: require("../../../assets/pumpopen.png"),
                },
                FAN: {
                    url: require("../../../assets/fansopen.png"),
                },
                IronPump: {
                    url: require("../../../assets/IronPump (2).png"),
                }
            },
            img1: {
                PAM: {
                    url: require("../../../assets/PAMclose.png")
                },
                PAC: {
                    url: require("../../../assets/PACclose.png")
                },
                CARBON: {
                    url: require("../../../assets/pumpclose.png"),
                },
                FAN: {
                    url: require("../../../assets/newfjclose.png"),
                },
                IronPump: {
                    url: require("../../../assets/IronPump (3).png"),
                }
            },
            img2: {
                PAM: {
                    url: require("../../../assets/29 (1).png")
                },
                PAC: {
                    url: require("../../../assets/27 (1).png")
                },
                CARBON: {
                    url: require("../../../assets/22 (2).png"),
                },
                FAN: {
                    url: require("../../../assets/26.png"),
                },
                IronPump: {
                    url: require("../../../assets/IronPump (1).png"),
                }
            },
            justdo: null,
            haveai: false,
            ai_mode: null,
            equiplabel: null,
            equipunit: null
        };
    },

    watch: {

    },
    mounted() {
        this.justdo = "fc";
        this.openIndex = this.$route.query.index;
        // this.getEquipData(this.openIndex)
        setTimeout(() => {
            this.getEquipData(this.openIndex);
        }, 150);
        this.timer = window.setInterval(async () => {
            setTimeout(await this.getEquipData(this.openIndex), 0);
        }, 300000);
        this.getaimode()

        // // this.getControlData(this.openIndex);
        // this.getChartData();
        // this.timer = window.setInterval(() => {
        //     setTimeout(this.getChartData(), 0);
        // }, 300000)
    },
    methods: {
        async getaimode() {
            const { data: res } = await this.$http.get("/modules/init", {
                params: { index: this.openIndex },
            });
            console.log(1231231233333333);
            console.log(res.data.result.ai_mode[0]);
            if (res.data.result.ai_mode.length > 0) {

                this.ai_mode = res.data.result.ai_mode[0].flag
                this.ai_id = res.data.result.ai_mode[0].id
                this.haveai = true
            } else {
                this.haveai = false
            }
        },
        async changeAimode() {
            const { data: res } = await this.$http.post("/modules/aimode", {
                "index": this.openIndex,
                "id": this.ai_id,
                "flag": this.ai_mode
            });
            console.log(res);
            if (res.meta.status == 200) {
                if (res.data.flag == true) {
                    return this.$message({
                        type: "success",
                        message: "开启雨天应急模式成功",
                    });
                } else {
                    return this.$message({
                        type: "success",
                        message: "关闭雨天应急模式成功",
                    });
                }
            } else {
                if (this.ai_mode) {
                    this.ai_mode = false
                } else {
                    this.ai_mode = true
                }
                console.log(res.meta.msg);
                // this.getEquipData(this.openIndex);
                return this.$message({
                    type: "error",
                    message: res.meta.msg,
                });
            }
        },
        async clicktag(item, index) {
            this.changetag = false
            console.log(item);
            this.tagclick = index
            const { data: res } = await this.$http.get("/modules/chart/recent", {
                params: {
                    tag: item.tag
                },
            });
            let chartData1 = {
                xAxis: null,
                legend: null,
                title: ''
            }
            chartData1.xAxis = res.data.result.xAxis
            chartData1.title = item.name
            chartData1.legend = {
                name: item.name,
                tag: [res.data.result.legend[0].tag],
                unit: item.unit,
                yAxis: res.data.result.legend[0].yAxis
            }
            // this.chartData = this.chartData1
            this.chartData = chartData1
            this.changetag = true
            console.log(this.chartData);
        },
        choseitem(item) {
            this.choseid = item.id
        },
        //获取设备数据
        async getEquipData(index) {
            this.goto = false
            const { data: res } = await this.$http.get("/modules/facilities", {
                params: { index: index },
            });
            console.log(res.data);
            this.goto = true

            this.equipTitle = res.data.result.name;
            this.equiplabel = res.data.result.label
            this.equipunit = res.data.result.unit
            this.facilitiesData = res.data.result.facilities;
            this.eqlength = res.data.result.facilities.length
            this.equipmentdetail = this.facilitiesData[this.cliskindex]
            this.chartData = this.equipmentdetail.chart
            console.log(this.chartData);
            this.changetag = true
            console.log(this.facilitiesData.length);
            if (this.facilitiesData.length < 4) {
                console.log(123123131);
                this.drawer = true
            }
            console.log(this.facilitiesData);
            // this.index = Math.floor(24 / this.facilitiesData.length);
            // if (this.facilitiesData.length > 5) {
            //     this.index = Math.ceil(24 / 5);
            // }


        },
        cbrBtnStyle(index) {
            if (this.allControlData.result.pool[index].flag == true) {
                return { backgroundColor: "#1890ff", color: "fff" };
            } else {
                return { backgroundColor: "#b8b8b8", color: "fff" };
            }
        },
        // async getChartData() {
        //     const { data: res } = await this.$http.get( + "/modules/extra", {
        //         params: { type: "chart" },
        //     });
        //     this.chartData = res.data.result[0];
        //     console.log(this.chartData);
        //     this.activeName = this.chartData.type
        //     this.changeChart(this.chartData.data[0])
        // },
        changeChart(item) {
            console.log(item);
            this.bigchartdata = item;
            console.log(item);
        },
        handleClick(tab, event) {
            this.changeChart(this.chartData[tab.index].data[0])
        },
        choseeq(i, index) {
            if (
                this.cliskindex == index
            ) {
                this.drawer = !this.drawer
            } else {
                this.drawer = true
            }
            this.cliskindex = index
            this.equipmentdetail = this.facilitiesData[this.cliskindex]
            this.chartData = this.equipmentdetail.chart
            this.tagclick = 0
            // this.getEquipData(this.cliskindex)

            console.log(i, index);
            // this.changeChart(this.chartData[tab.index].data[0])
        },
        closedrawer() {
            this.drawer = false
            this.cliskindex = null
        },

        async changeSwitch(item) {
            console.log(item);
            event.stopPropagation();
            // console.log(item);
            const { data: res } = await this.$http.post("/modules/facilitybtn", {
                "index": this.openIndex,
                "id": item.ctrl_btn.btn_id,
                "flag": !item.ctrl_btn.enable
            });
            this.getEquipData(this.openIndex)

        },
        onmouserin() {
        }
    },
};
</script>

<style lang="scss" scoped>
.equipment_cont {
    position: relative;
    overflow: hidden;
    background-color: #212121FF;
    border-radius: 26px;

    .equipment_box {
        display: flex;
        justify-content: space-between;
        left: 774px;
        top: 774px;
        width: 1190.8px;
        height: 490px;
        opacity: 1;
        border-radius: 26px;
        // background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);
        // position: relative


        .equipment_left {
            margin-top: 21px;
            margin-left: 42px;
            // background-color: red;

            .equipment_name {
                font-size: 18px;
                font-weight: 600;
                letter-spacing: 0px;
                line-height: 33.88px;
                color: #C5C5C5;
            }

            .equipment_unit {
                font-size: 16px;
                font-weight: 500;
                letter-spacing: 0px;
                line-height: 26.35px;
                color: rgba(166, 166, 166, 1);
                text-align: left;
                vertical-align: top;
            }

            .equipment_list {
                width: 1150px;
                overflow-x: overlay;
                overflow-y: visible;
                padding-top: 43px;
                display: flex;
                padding-bottom: 30px;

                .info_box {
                    display: flex;
                    cursor: pointer;
                    // text-align: center;
                }

                .kedu {
                    height: 263.9px;
                    margin-left: 10px;
                    width: 50px;
                    position: relative;

                    // background-color: red;
                    .goaltag {
                        position: absolute;
                        right: 0;
                        display: flex;
                        align-items: center;
                        justify-content: end;
                        // background: rgba(189, 89, 87, 1);

                        .short {
                            margin-left: 10px;
                            // margin-bottom: 20px;
                            width: 12px;
                            height: 2px;
                            opacity: 1;
                            background: rgba(189, 89, 87, 1);
                        }
                    }

                    .tag {
                        text-align: right;
                        display: flex;
                        align-items: center;
                        justify-content: end;
                        font-size: 12px;
                        margin-bottom: 22px;
                        color: #616161;

                        .long {
                            margin-left: 10px;
                            // margin-bottom: 20px;
                            width: 20px;
                            height: 2px;
                            opacity: 1;
                            background: rgba(204, 204, 204, 1);
                        }

                        .long2 {
                            margin-left: 10px;
                            width: 20px;
                            height: 2px;
                            opacity: 1;
                            background: #40E0D0;
                        }

                        .short {
                            margin-left: 10px;

                            // margin-bottom: 20px;
                            width: 12px;
                            height: 2px;
                            opacity: 1;
                            background: rgba(189, 89, 87, 1);
                        }

                        .short2 {
                            // margin-bottom: 20px;
                            margin-left: 10px;
                            width: 12px;
                            height: 2px;
                            opacity: 1;
                            background: rgba(204, 204, 204, 1);
                        }
                    }
                }

                .list_info {
                    display: flex;
                    justify-content: center;
                    align-items: flex-end;
                    margin-left: 17px;
                    margin-right: 17px;
                    width: 57px;
                    height: 263.9px;
                    opacity: 1;
                    border-radius: 7.8px;
                }

                .closeinfo {
                    background: #616161;
                    border: 1.3px solid #616161;
                }

                .openinfo {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: rgba(250, 250, 250, 1);
                    width: 54.6px;
                    // background-color: #DEDEDE;
                    // height: 15%;
                    opacity: 1;
                    border-radius: 7.8px;
                    background: linear-gradient(180deg, #40E0D0 0%, #008080 100%);
                }

                .errorinfo {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;

                    img {
                        width: 29px;
                        height: 25px;
                    }
                }

                .openinfobox {
                    opacity: 1;
                    // background-color: #616161;
                    border-radius: 7.8px;
                    border: 1.3px solid #40E0D0;
                }

                .info_text {
                    margin-top: 8px;
                    margin-bottom: 6px;
                    text-align: center;
                    // background-color: #DEDEDE;
                    // background-color: red;
                    font-size: 17px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 21.33px;
                    color: rgba(184, 184, 184, 1);
                    // text-align: left;
                    vertical-align: top;
                }

                .info_status {
                    // text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .status {

                        width: 55.9px;
                        height: 5.82px;
                        opacity: 1;
                        border-radius: 5.2px;
                        // background: rgba(67, 142, 217, 1);
                        box-shadow: 0px 2.6px 5.2px rgba(0, 0, 0, 0.05);
                    }

                    .closetype {
                        background: rgba(222, 222, 222, 1)
                    }

                    .opentype {
                        background: #40E0D0
                    }

                    .errortype {
                        background: #BD5957
                    }
                }
            }

            .equipment_list::-webkit-scrollbar {
                width: 5px !important;
                height: 5px !important;
            }

            .equipment_list::-webkit-scrollbar-track {
                background: rgb(239, 239, 239);
                border-radius: 2px;
            }

            .equipment_list::-webkit-scrollbar-thumb {
                background: #bfbfbf;
                border-radius: 10px;
            }

            .equipment_list::-webkit-scrollbar-thumb:hover {
                background: #bfbfbf;
            }
        }

        .equipment_right {
            position: absolute;
            left: 540px;
            width: 650px;
            height: 474.5px;
            opacity: 1;
            border-radius: 26px;
            background: #2E2E2E;
            box-shadow: -6.5px 0px 9.1px rgba(0, 0, 0, 0.05);

            .close_btn {
                float: right;
                margin-right: 20px;
                margin-top: 20px;

                img {
                    left: 1926.6px;
                    top: 799.5px;
                    width: 18.2px;
                    height: 18.2px;
                    opacity: 1;
                }
            }

            .right_top {
                margin-top: 43px;
                margin-left: 69px;
                margin-bottom: 33px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .equipment_img {
                    margin-right: 34px;

                    img {
                        left: 1383.2px;
                        top: 817.13px;
                        width: 78px;
                        height: 78px;
                        opacity: 1;
                    }
                }

                .equipment_text {
                    .equipment_num {
                        font-size: 23.4px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 33.88px;
                        color: #C5C5C5;
                        text-align: left;
                        vertical-align: top;
                    }

                    .equipment_type {
                        font-size: 18.2px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 26.35px;
                        color: rgba(97, 97, 97, 1);
                        text-align: left;
                        vertical-align: top;
                    }
                }

                .equipment_open {
                    margin-right: 81px;
                    text-align: center;
                    cursor: pointer;

                    img {
                        left: 1848.6px;
                        top: 849.67px;
                        width: 35.1px;
                        height: 32.8px;
                        opacity: 1;
                        // background: rgba(23, 130, 212, 1);
                    }

                    span {
                        font-size: 16.9px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24.47px;
                        color: rgba(130, 130, 130, 1);
                        text-align: left;
                        vertical-align: top;
                    }
                }
            }

            .right_mid {
                margin-left: 32px;
                max-width: 572px;
                border-top: 1px solid rgba(199, 199, 199, 1);

                .mid_box {
                    display: flex;
                    justify-content: space-between;
                    margin-left: 43px;
                    margin-right: 43px;

                    .equipment_tag {
                        cursor: pointer;
                        text-align: center;
                        min-width: 94.46px;
                        font-size: 18.2px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 26.35px;
                        // color: rgba(67, 142, 217, 1);
                        // text-align: left;
                        // vertical-align: top;
                    }

                    .click_tag {
                        border-top: 4px solid #008080;
                        color: #008080;
                    }

                    .setp {
                        margin-top: 10px;
                        margin-bottom: 0;
                    }

                    .valuep {
                        margin-top: 5px;
                        margin-bottom: 0;

                        .kongge {
                            display: inline-block;
                            width: 8px;
                        }
                    }
                }
            }

            .right_chart {
                margin-left: 32px;

                .minichartbox {
                    height: 180px;
                }

                .chart_title {
                    margin-bottom: 5px;
                    font-size: 15.6px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18.28px;
                    color: rgba(238, 104, 75, 1);
                    text-align: left;
                    vertical-align: top;
                }

                .chart_box {
                    max-width: 572px;
                    border-top: 0.78px dashed rgba(255, 87, 51, 1);

                }
            }
        }

        .openright {
            width: 650px;
            height: 474.5px;
            position: absolute;
            left: 540px;
            transition: all 0.3s;
        }

        .moveR-enter-active,
        .moveR-leave-active {
            transition: all 0.3s linear;
            transform: translateX(0);
        }

        .moveR-enter,
        .moveR-leave {
            transform: translateX(100%);
        }

        .moveR-leave-to {
            transform: translateX(100%);
        }

        .closeright {
            position: absolute;
            left: 1200px;
        }
    }

    .fc {
        animation: wm 0.8s infinite linear;
    }

    @keyframes wm {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(360deg);
        }
    }
}
</style>
